import { compareOwnedDraftFirst, isOwnedBuilderDraft } from "@patient-watch/forms";

export { compareOwnedDraftFirst, isOwnedBuilderDraft };

/** Forms/schedules paths clinicians were allowed to open. Kept for callers / future re-enable. */
export function isClinicianBuilderPath(pathname: string): boolean {
    return (
        pathname === "/builder" ||
        pathname === "/builder/" ||
        pathname === "/builder/forms" ||
        pathname.startsWith("/builder/forms/") ||
        pathname === "/builder/schedules" ||
        pathname.startsWith("/builder/schedules/")
    );
}

/**
 * Route gate for `/builder/*`. Clinician access is paused (nav + picker "Add" links hidden)
 * until public Builder has had user testing.
 */
export function canOpenBuilder({ isAdmin }: { isAdmin: boolean; isClinician?: boolean; pathname?: string }): boolean {
    return isAdmin;
}

export function canPickBuilderItem({
    isAdmin,
    isPublished,
    authorId,
    currentUserId,
}: {
    isAdmin: boolean;
    isPublished?: boolean | null;
    authorId?: string | null;
    currentUserId?: string | null;
}): boolean {
    if (isAdmin) return true;
    if (isPublished === true) return true;
    return Boolean(currentUserId && authorId === currentUserId);
}

export function filterBuilderPickerItems<T extends { author?: string | null; is_published?: boolean | null }>(
    items: T[],
    { isAdmin, userId }: { isAdmin: boolean; userId?: string | null }
): T[] {
    return items.filter((item) =>
        canPickBuilderItem({
            isAdmin,
            isPublished: item.is_published,
            authorId: item.author,
            currentUserId: userId,
        })
    );
}

export function filterClinicianBuilderRows<T extends { author?: string | null }>(
    rows: T[],
    { isAdmin, userId }: { isAdmin: boolean; userId?: string | null }
): T[] {
    if (isAdmin) return rows;
    return rows.filter((row) => row.author === userId);
}
